export const TEXTS: string[] = [
  "I like programming",
  "I like algorithms",
  "I like to create custom charts",
  "I like rxjs",
  "I like geometry",
  "I like math",
  "I like engineering",
  "I play the violin",
  "I am ready to help",
  "I am a frontend developer",
  "I have a bachelor degree in Software Engineering",
  "I practise shader programming here",
  "I live in Kyiv",
  "I love my wife",
];
